export const isSafariBrowser = () => {
	try {
		const isSafariBrowser = /^(?!.*(Chrome|Chromium)).*Safari/.test(navigator.userAgent);
		return isSafariBrowser;
	} catch {
		return false;
	}
};
